import { COLORS } from '@lemonade-hq/tokens';
import React from 'react';
import styled from 'styled-components';
import {
  OdometerDesktopFirstDigit as Digit,
  ODOMETER_DELAY,
  OdometerSymbol as OSymbol,
  OdometerWrapper as Wrapper,
} from '../GivebackShared/odometerHelpers';

const ProblematicSymbol = styled(OSymbol)`
  @media (min-width: 769px) and (max-width: 840px) {
    display: none;
  }
`;

const ProblematicDigit = styled(Digit)`
  @media (min-width: 769px) and (max-width: 840px) {
    display: none;
  }
`;

const Giveback2021RisingNumber: React.FC<{ mb: number[]; height: number[] }> = props => {
  return (
    <Wrapper {...props}>
      <OSymbol style={{ animationDelay: `${ODOMETER_DELAY * 5}ms` }}>$</OSymbol>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 5}ms` }}>&nbsp; 0 1 2</Digit>
      <OSymbol style={{ width: '0.18em', animationDelay: `${ODOMETER_DELAY * 3.2}ms` }}>,</OSymbol>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 4.5}ms` }}>&nbsp; 1 2 3</Digit>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 4}ms` }}>&nbsp; 0 0 0</Digit>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 3.5}ms` }}>&nbsp; 1 2 3</Digit>
      <OSymbol style={{ width: '0.23em', animationDelay: `${ODOMETER_DELAY * 2}ms` }}>,</OSymbol>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 3}ms` }}>&nbsp; 1 2 3</Digit>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 2.5}ms` }}>&nbsp; 6 7 8</Digit>
      <Digit style={{ animationDelay: `${ODOMETER_DELAY * 2}ms` }}>&nbsp; 0 0 1</Digit>
      <ProblematicSymbol style={{ width: '0.26em', color: COLORS.pink }}>.</ProblematicSymbol>
      <ProblematicDigit style={{ animationDelay: `${ODOMETER_DELAY * 1.5}ms` }}>&nbsp; 0 1 2</ProblematicDigit>
      <ProblematicDigit style={{ animationDelay: `${ODOMETER_DELAY}ms` }}>&nbsp; 2 3 4</ProblematicDigit>
    </Wrapper>
  );
};

export default React.memo(Giveback2021RisingNumber);
